module.exports = __webpack_public_path__ + "img/ISO2.16266ccc.jpg";